import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResultsComponent } from './results.component';
import { Routes, RouterModule } from '@angular/router';
import { MaterialModule } from '../material.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ResultsService } from './results.service';
import { FormsModule } from '@angular/forms';
import { ClipboardModule } from 'ngx-clipboard';
import { SharedModule } from '../shared.module';

export const ResultsRoutes: Routes = [
  {
      path: "",
      component: ResultsComponent
  }
];

@NgModule({
  declarations: [ResultsComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FontAwesomeModule,
    FormsModule,
    RouterModule.forChild(ResultsRoutes),
    ClipboardModule,
    SharedModule
  ],
  providers: [
    ResultsService
  ],
  
})
export class ResultsModule { }
